// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__g0dAP","spinner":"Loading_spinner__2W9S3"};